

export const MenuItems = [
    {
        'title':"Home",
        "url":"#home",
        "className": "nav-link"
    },
    {
        'title':"About",
        "url":"#about",
        "className": "nav-link"
    },
    {
        'title':"Skills",
        "url":"#skills",
        "className": "nav-link"
    },
    {
        'title':"Projects",
        "url":"#projects",
        "className": "nav-link"
    },
    {
        'title':"Contacts",
        "url":"#contacts",
        "className": "nav-link"
    },
]